import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-216ef1e0")

_pushScopeId("data-v-216ef1e0")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "text-primary text-center"
}
const _hoisted_3 = { class: "trainer-rating-container" }
const _hoisted_4 = { class: "rating-display" }
const _hoisted_5 = { class: "rating-average-display" }
const _hoisted_6 = {
  key: 0,
  class: "rating-display"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Rate Trainer")
const _hoisted_8 = {
  key: 1,
  class: "trainer-actions"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Workouts")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Services")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "video-info" }
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h1", null, "30", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("h6", null, "On Demand Library Subscription", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, "10 new videos added each week", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "wrapped-text" }, "45 videos", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("h6", null, "Weekly Live Workouts", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("p", null, "10 live workouts per week", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("h6", null, "60 Minutes One on One Video Coaching", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("h6", null, "Diet and Health Coaching", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("h1", { class: "ion-text-center" }, "Bio", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_ion_back_button = _resolveComponent("ion-back-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          (_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_Navbar, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.isWeb)
            ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                default: _withId(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_back_button, {
                        icon: "chevron-back",
                        text: "",
                        color: "medium",
                        onClick: _cache[1] || (_cache[1] = () => _ctx.returnHome())
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { color: "medium" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.trainer.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, {
                  class: "border-bottom",
                  style: {"padding-bottom":"20px","margin-bottom":"10px"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      sizeLg: "12"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", {
                          class: "trainer-image",
                          style: {
									background: 'url(assets/trainer-bg.jpg)',
								}
                        }, null, 4),
                        _createVNode(_component_ion_avatar, { class: "trainer-avatar ion-align-self-center" }, {
                          default: _withId(() => [
                            _createVNode("img", {
                              src: _ctx.trainer.imgURL
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }),
                        (_ctx.isWeb)
                          ? (_openBlock(), _createBlock("h3", _hoisted_2, _toDisplayString(_ctx.trainer.name), 1))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_3, [
                          _createVNode("div", _hoisted_4, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.createStars(), (starIcon, index) => {
                              return (_openBlock(), _createBlock(_component_ion_icon, {
                                color: "primary",
                                key: index,
                                icon: starIcon
                              }, null, 8, ["icon"]))
                            }), 128))
                          ]),
                          _createVNode("div", _hoisted_5, "(" + _toDisplayString(_ctx.rating) + ")", 1),
                          (_ctx.isAuth)
                            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                                _createVNode(_component_ion_button, {
                                  color: _ctx.getColor(),
                                  size: "md",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateTrainerRating())),
                                  style: [
											_ctx.trainer?.mirror && !_ctx.isWeb
												? { width: '80% !important' }
												: {},
										]
                                }, {
                                  default: _withId(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }, 8, ["color", "style"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.client?.coaches_enabled && _ctx.isAuth)
                          ? (_openBlock(), _createBlock("div", _hoisted_8, [
                              _createVNode(_component_ion_button, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openMessages(_ctx.trainer))),
                                color: "primary",
                                size: "medium"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_icon, {
                                    size: "medium",
                                    icon: _ctx.chatboxOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openVideoBookings(_ctx.trainer))),
                                color: "primary",
                                size: "medium"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_icon, {
                                    size: "medium",
                                    icon: _ctx.videocamOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openCallBooking(_ctx.trainer))),
                                color: "primary",
                                size: "medium"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_icon, {
                                    size: "medium",
                                    icon: _ctx.callOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "text-center"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_button, {
                          size: "medium",
                          color: _ctx.classesColor,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showTab('classes')))
                        }, {
                          default: _withId(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["color"]),
                        (_ctx.client?.coaches_enabled)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              size: "medium",
                              color: _ctx.servicesColor,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showTab('services')))
                            }, {
                              default: _withId(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["color"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_button, {
                          size: "medium",
                          color: _ctx.bioColor,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showTab('bio')))
                        }, {
                          default: _withId(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.showClasses)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_row, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_col, null, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.trainer.name) + "'s Classes", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_row, null, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trainerVids, (classObject, index) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                size: "12",
                                "size-xl": "4",
                                "size-lg": "4",
                                "size-md": "4",
                                "size-sm": "12",
                                key: index
                              }, {
                                default: _withId(() => [
                                  (_ctx.isAuth)
                                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                                        (_ctx.isBookmarked(classObject))
                                          ? (_openBlock(), _createBlock(_component_ion_button, {
                                              key: 0,
                                              class: "bookmarkBtn",
                                              fill: "clear",
                                              onClick: ($event: any) => (_ctx.removeBookmark(classObject))
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_ion_icon, {
                                                  icon: _ctx.bookmark,
                                                  color: "light"
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          : (_openBlock(), _createBlock(_component_ion_button, {
                                              key: 1,
                                              class: "bookmarkBtn",
                                              fill: "clear",
                                              onClick: ($event: any) => (_ctx.addBookmark(classObject))
                                            }, {
                                              default: _withId(() => [
                                                _createVNode(_component_ion_icon, {
                                                  color: "light",
                                                  icon: _ctx.bookmarkOutline
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_card, {
                                    button: "",
                                    onClick: ($event: any) => (_ctx.openModal(classObject)),
                                    class: "category-card"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_badge, {
                                        color: "primary",
                                        class: "class-badge"
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(classObject.isLive ? "LIVE" : "On Demand"), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_img, {
                                        src: classObject?.imgURL
                                      }, null, 8, ["src"]),
                                      _createVNode("div", _hoisted_13, [
                                        _createVNode("b", null, _toDisplayString(classObject?.duration) + " Minute " + _toDisplayString(classObject?.name), 1),
                                        _hoisted_14,
                                        _createVNode("span", _hoisted_15, _toDisplayString(classObject.trainerData.name) + " | " + _toDisplayString(classObject?.categoryName), 1),
                                        (_ctx.hasProgressed(classObject))
                                          ? (_openBlock(), _createBlock(_component_ion_badge, {
                                              key: 0,
                                              color: "dark",
                                              class: "class-watched"
                                            }, {
                                              default: _withId(() => [
                                                _createTextVNode(_toDisplayString(_ctx.progressType(classObject.classID)), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showServices)
                  ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, {
                          "size-sm": "12",
                          "size-md": "3",
                          class: "service-container"
                        }, {
                          default: _withId(() => [
                            _hoisted_16,
                            _hoisted_17,
                            _hoisted_18,
                            _hoisted_19
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          "size-sm": "12",
                          "size-md": "3",
                          class: "service-container"
                        }, {
                          default: _withId(() => [
                            _hoisted_20,
                            _hoisted_21
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          "size-sm": "12",
                          "size-md": "3",
                          class: "service-container"
                        }, {
                          default: _withId(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, {
                          "size-sm": "12",
                          "size-md": "3",
                          class: "service-container"
                        }, {
                          default: _withId(() => [
                            _hoisted_23
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showBio)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 2,
                      class: "ion-margin-horizontal"
                    }, {
                      default: _withId(() => [
                        _hoisted_24,
                        _createVNode("p", null, [
                          _createVNode("span", {
                            innerHTML: _ctx.trainer.bio
                          }, null, 8, ["innerHTML"])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      (!_ctx.isWeb)
        ? (_openBlock(), _createBlock(_component_bottombar, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})